function endsWith(str, suffix) {
    return str.indexOf(suffix, str.length - suffix.length) !== -1
}

const apiRoot =
    window.location.hostname.includes('.ru') && process.env.REACT_APP_API_ROOT_RU
        ? process.env.REACT_APP_API_ROOT_RU
        : process.env.REACT_APP_API_ROOT

const API_ROOT = endsWith(apiRoot ?? '', '/') ? apiRoot : apiRoot + '/'

export const environment = {
    isDisableCheckAppVersion: process.env.REACT_APP_CHECK_APP_VERSION?.toLowerCase() == 'false',
    isDisableTrackAppState: process.env.REACT_APP_TRACK_APP_STATE?.toLowerCase() == 'false',
    isDisableTrackUSerState: process.env.REACT_APP_TRACK_USER_STATE?.toLowerCase() == 'false',
    isDevEnvironment: process.env.NODE_ENV === 'development',
    API_ROOT,
    TELEMOST_PUBLIC_URL_ROOT: process.env.REACT_APP_TELEMOST_PUBLIC_URL_ROOT
}
